module.exports = __webpack_public_path__ + "static/img/home_tp.fb01d8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_tp.png
// module id = BfL+
// module chunks = 0